import { OffersTypes } from './types'
import { Action } from '../types'
import { OfferInput } from '../../types/skus'

export type OfferSavePayload = OfferInput

export type OfferEditPayload = {
  indexTable: number,
  data: OfferInput
}

type OfferAction =
  Action<OffersTypes, OfferSavePayload> |
  Action<OffersTypes, OfferSavePayload[]> |
  Action<OffersTypes, number> |
  Action<OffersTypes, OfferEditPayload>

const initialState: OfferInput[] = []

export function offersReducer(
  state = initialState,
  action: OfferAction
): OfferInput[] {
  const {
    type,
    payload
  } = action

  if (type === OffersTypes.SAVE_OFFER) {
    const data = payload as OfferSavePayload
    return sortOffers([...state, data])
  } else if (type === OffersTypes.EDIT_OFFER) {
    const {
      indexTable,
      data
    } = payload as OfferEditPayload

    state[indexTable!] = {
      ...data,
      isUpdated: data.id ? true : undefined
    }
    return sortOffers([...state])
  } else if (type === OffersTypes.SAVE_OFFERS) {
    const data = payload as OfferSavePayload[]
    return sortOffers([...state, ...data])
  } else if(type === OffersTypes.REMOVE_OFFER) {
    const item  = state.find((_, index) => index === payload)

    let offers: OfferInput[]

    if (item?.id) {
      offers = state.map((item, index) => {
        if (index === payload) {
          return {
            ...item,
            isChurn: true,
            payment: {}
          }
        }

        return item
      })
    } else {
      offers = state.filter((_, index) => index !== payload)
    }

    return sortOffers(offers)
  }

  return state
}


const sortOffers = (offers: OfferInput[]) => {
  return offers.sort((a: OfferInput, b: OfferInput) => {
    if(!a.id && b.id) {
      return -1
    } else if(a.id && a.isUpdated && b.id && !b.isUpdated) {
      return -1
    }
    return 1
  })
}
